export class Constants {
    public static readonly CODE_PREFIX = "NF"
}